import * as codeSystems from '@seen/core/codeSystems'
import { Badge } from '@seen/ui'
import type { JSX } from 'react'

const COLOR: Record<
  codeSystems.ProviderNetworkStatus,
  'blue' | 'green' | 'gray'
> = {
  internal: 'blue',
  'in-network': 'green',
  'non-network': 'gray',
}

// Read-only indicator of a provider's derived network status. Reused by the
// admin catalog and the Send Fax recipient indicator, for Practitioners and
// Organizations alike.
export function NetworkStatusBadge({
  status,
}: {
  status: codeSystems.ProviderNetworkStatus
}): JSX.Element {
  return (
    <Badge variant="outline" color={COLOR[status]}>
      {codeSystems.PROVIDER_NETWORK_STATUS_DISPLAY[status]}
    </Badge>
  )
}
